export default "__VITE_ASSET__d9bGlYCB__"